import {Employee} from "@models/employee.model.ts";

export class Todo {
  id: number;
  name : string;
  description: string;
  sequence: number;
  status: string;
  due_date: string | null;
  owner_type: string;
  comments_count: number;
  assigned_to: Employee;

  constructor() {
    this.id = -1;
    this.name  = "";
    this.description = "";
    this.sequence = 0;
    this.status = "";
    this.due_date = "";
    this.owner_type = "";
    this.comments_count = 0;
    this.assigned_to = new Employee();
  }
}
